import { Container, Col, Row } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Title from "./Conponents/Title/Title";
import Timeline from "../../../../../components/Timeline/timeline";
import BackArrow from "../../../../../components/backArrow";
import { useNavigate } from "react-router-dom";
import { getAsset } from "../../../../../helpers/helper";
import { useViewFriendsState } from "../../../../../hooks/useViewFriendsState";
import dummyUser from "../../../../../assets/images/dummy/user-avatar-img.jpg";
import { PaginationControl } from "react-bootstrap-pagination-control";
import { encodeId } from "../../../../../utils/idObfuscator";

/* Resolve connection avatar for string OR array image fields.
 * NOTE: do not use image[0] on a string — that is the first character ("/"). */
const resolveFriendAvatar = (item) => {
  if (!item) return dummyUser;
  const candidates = [
    item.image,
    item.imageUrl,
    item.profileImage,
    item.userImage,
    item.avatar,
    item.sendershopimage,
    item.recievershopimage,
    item.senderUser?.imageUrl,
    item.receiverUser?.imageUrl,
    item.senderUser?.image,
    item.receiverUser?.image,
  ];
  for (const field of candidates) {
    if (field == null || field === "" || field === "N/A") continue;
    if (Array.isArray(field)) {
      const first = field
        .flat(Infinity)
        .find((v) => v && v !== "N/A" && String(v).trim());
      if (first) return getAsset(first);
      continue;
    }
    const s = String(field).trim();
    if (s && s !== "N/A") return getAsset(s);
  }
  return dummyUser;
};

/* ─── No-data empty state ─── */
const NoDataFound = ({ message = "No results found" }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "40px 20px",
      width: "100%",
      color: "#9ca3af",
    }}
  >
    {/* Searching-face SVG emoji */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width="72"
      height="72"
      style={{ marginBottom: "12px", opacity: 0.75 }}
      aria-hidden="true"
    >
      {/* Face */}
      <circle cx="50" cy="50" r="45" fill="#FDE68A" stroke="#F59E0B" strokeWidth="2.5" />
      {/* Left eye */}
      <circle cx="35" cy="40" r="5" fill="#374151" />
      <circle cx="36.5" cy="38.5" r="1.5" fill="#fff" />
      {/* Right eye – looking sideways (search-style) */}
      <circle cx="65" cy="40" r="5" fill="#374151" />
      <circle cx="66.5" cy="38.5" r="1.5" fill="#fff" />
      {/* Sad / puzzled mouth */}
      <path
        d="M 36 64 Q 50 58 64 64"
        fill="none"
        stroke="#374151"
        strokeWidth="2.8"
        strokeLinecap="round"
      />
      {/* Magnifying glass */}
      <circle cx="72" cy="72" r="9" fill="none" stroke="#6B7280" strokeWidth="3" />
      <line x1="78.5" y1="78.5" x2="86" y2="86" stroke="#6B7280" strokeWidth="3.5" strokeLinecap="round" />
    </svg>

    <p
      style={{
        margin: 0,
        fontSize: "13px",
        fontWeight: 600,
        color: "#6b7280",
        letterSpacing: "0.3px",
      }}
    >
      {message}
    </p>
    <p style={{ margin: "4px 0 0", fontSize: "11px", color: "#9ca3af" }}>
      Try a different search term
    </p>
  </div>
);

/* ─── Skeleton shimmer styles (injected once) ─── */
const skeletonStyle = `
  @keyframes skeletonShimmer {
    0%   { background-position: -400px 0; }
    100% { background-position: 400px 0; }
  }
  @keyframes fadeIn {
    from { opacity: 0.3; }
    to { opacity: 1; }
  }
  .fade-in {
    animation: fadeIn 0.4s ease-out forwards;
  }
  .sk-pulse {
    background: linear-gradient(90deg, #ebebeb 25%, #d6d6d6 50%, #ebebeb 75%);
    background-size: 800px 100%;
    animation: skeletonShimmer 1.4s ease-in-out infinite;
    border-radius: 4px;
  }
  .sk-avatar {
    width: 52px;
    height: 52px;
    border-radius: 50%;
  }
  .friend-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    min-height: 140px;
    padding: 8px 4px;
    gap: 6px;
  }
`;

/* ─── Business-type route map ─ */
const businessTypeRoutes = {
  homemadeShop: "/Home-Made-Item-Userprofile/",
  gemShop: "/Minerl-And-Mining-UserProfile/",
  services: "/services-online/",
  usedShop: "/usedItems-userprofile/",
  rawmaterialShop: "/rawmaterial-userprofile/",
  manufacturerShop: "/manufacturer-userprofile/",
  wholesellerShop: "/wholeseller-userprofile/",
  retailerShop: "/retailer-userprofile/",
  recycledShop: "/Recycleuserprofile/",
  farmingShop: "/Farminguserprofile/",
  usedVehicleShop: "/Byvehicleuserprofile/",
  transportShop: "/buying-transport/",
  businessPropertyCompany: "/user-peronal-property/",
  foodShop: "/food-buying-profile/",
  company: "/find-jobs-online/",
  jobsCompany: "/find-jobs-online/",
  generalPublic: "/other-profile/",
  marketerProfile: "/view-marketer-profile/",
  "Approved Marketers": "/view-marketer-profile/",
};

/* ─── Skeleton card (shown while data is loading) ── */
const SkeletonCard = () => (
  <Col lg="3" md="3" sm="12" className="mt-2 fade-in">
    <div className="friend-card border p-2" style={{ borderRadius: "8px", backgroundColor: "#fff" }}>
      <div className="sk-pulse sk-avatar" />
      <div className="sk-pulse" style={{ width: "75%", height: "11px" }} />
      <div className="sk-pulse" style={{ width: "55%", height: "10px" }} />
      <div className="sk-pulse" style={{ width: "70px", height: "24px", borderRadius: "6px" }} />
    </div>
  </Col>
);

const SKELETON_COUNT = 8;

/* ─── Main component ─── */
const Viewfriends = ({ id, mybusinessType }) => {
  const navigate = useNavigate();

  const {
    key,
    setKey,
    searchText,
    setSearchText,
    createPost,
    setCreatePost,
    loading,
    isConnectedLoading,
    isRandomLoading,
    tabsData,
    activeTab,
    handleTabSelect,
    getActiveTabData,
    connectedData,
    filteredConnected,
    filteredRandom,
    sendingConnect,
    handleRemove,
    handleConnect,
    getConnectionStatus,
    selectedBT,
    fromMarketerProfile,
    page,
    setPage,
    total,
    randomPage,
    setRandomPage,
    randomTotal,
  } = useViewFriendsState({ id });

  const friendsTabTitle =
    selectedBT === "marketerProfile"
      ? fromMarketerProfile
        ? "Connected Marketers"
        : "Approved Marketers"
      : "My Friend's";

  const backPath = fromMarketerProfile ? "/marketing-profile" : "/user-profile";

  return (
    <>
      {/* ── Inject skeleton CSS once ─── */}
      <style>{skeletonStyle}</style>

      <Container className="mt-1">
        <Row className="gx-3">
          <Col lg="7" className=" screenHeight " sm="12">
            <div className="border ps-0 pe-0 height_100">
              <BackArrow back={backPath} mystyle="p-1 ps-2" />

              <Row>
                <Col lg="12">
                  <Tabs
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-3 display-setting font_sm d-flex justify-content-center"
                  >
                    {/* ================= MY FRIENDS ================= */}
                    <Tab eventKey="home" title={friendsTabTitle}>
                      <Title
                        searchText={searchText}
                        setSearchText={setSearchText}
                        name={connectedData?.businessType || ""}
                        title={`${connectedData?.count || filteredConnected.length || 0} ${connectedData?.businessType || ""
                          }`}
                      />

                      <div className="noscroll request_height">
                        <Row className="ps-4 pe-4 pt-2 pb-5 g-3">
                          {/* ── Skeleton while loading ── */}
                          {isConnectedLoading && filteredConnected.length === 0 ? (
                            Array.from({ length: SKELETON_COUNT }).map(
                              (_, i) => <SkeletonCard key={`sk-conn-${i}`} />
                            )
                          ) : filteredConnected.length === 0 ? (
                            /* ── No data found ── */
                            <NoDataFound
                              message={
                                searchText
                                  ? `No friends match "${searchText}"`
                                  : selectedBT === "marketerProfile"
                                    ? fromMarketerProfile
                                      ? "No connected marketers yet"
                                      : "No marketers found"
                                    : "No friends yet"
                              }
                            />
                          ) : (
                            filteredConnected.map((item, idx) => (
                              <Col
                                key={
                                  item?._id ||
                                  item?.shopid ||
                                  item?.userid ||
                                  `conn-${idx}`
                                }
                                lg="3"
                                md="3"
                                sm="12"
                                className="mt-2 fade-in"
                              >
                                <div className="friend-card border p-2" style={{ borderRadius: "8px", backgroundColor: "#fff" }}>
                                  {/* Avatar */}
                                  <img
                                    src={resolveFriendAvatar(item)}
                                    alt={item?.shopname || "User"}
                                    className="profile_img"
                                    crossOrigin="anonymous"
                                    onError={(ev) => {
                                      ev.currentTarget.src = dummyUser;
                                    }}
                                  />

                                  {/* Name */}
                                  <h6
                                    className="font-sm mb-0 text-truncate text-center w-100 px-1"
                                    title={item?.shopname || item?.fullname || item?.companyname || item?.profileName}
                                  >
                                    {item?.shopname || item?.fullname || item?.companyname || item?.profileName}
                                  </h6>

                                  {/* View shop */}
                                  <div
                                    className="font_11 mob_f font-grey"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      const userIdForProfile =
                                        item?.userid?._id ||
                                        item?.userid ||
                                        (!item?.shopid
                                          ? item?._id
                                          : null) ||
                                        null;
                                      const bt =
                                        item?.businessType ||
                                        connectedData?.businessType ||
                                        selectedBT;

                                      const hasShop = Boolean(
                                        (item?.shopid && item?.shopid !== "null") ||
                                        (bt && bt !== "generalPublic" && businessTypeRoutes[bt])
                                      );

                                      // Personal / GP connections without a shop → other-profile
                                      if (
                                        !hasShop &&
                                        (bt === "generalPublic" ||
                                          selectedBT === "generalPublic") &&
                                        userIdForProfile
                                      ) {
                                        navigate(
                                          `/other-profile/${encodeId(String(userIdForProfile))}`,
                                        );
                                        return;
                                      }

                                      const route =
                                        businessTypeRoutes[bt];
                                      const viewId =
                                        item?.shopid?._id ||
                                        item?.shopid ||
                                        item?.userid?._id ||
                                        item?.userid ||
                                        item?._id;
                                      if (route && viewId) {
                                        const finalId =
                                          bt === "marketerProfile"
                                            ? encodeId(viewId)
                                            : viewId;
                                        navigate(`${route}${finalId}`);
                                      }
                                    }}
                                  >
                                    <VisibilityIcon
                                      style={{ fontSize: "14px" }}
                                    />
                                    {selectedBT === "marketerProfile" ? "View Profile" : "View Shop"}
                                  </div>

                                  {/* Remove button — include marketer / marketing connected lists */}
                                  <button
                                    type="button"
                                    className="folow-btn mt-1"
                                    onClick={() => handleRemove(item)}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </Col>
                            ))
                          )}
                        </Row>
                      </div>

                      {total > 30 && (
                        <div className="mt-3 mb-2 d-flex justify-content-center">
                          <PaginationControl
                            page={page}
                            between={4}
                            total={total}
                            limit={30}
                            changePage={(p) => {
                              setPage(p);
                            }}
                            ellipsis={1}
                          />
                        </div>
                      )}
                    </Tab>

                    {/* ================= RANDOM PEOPLE ================= */}
                    {selectedBT !== "marketerProfile" && (
                      <Tab eventKey="profile" title="Random People">
                        <Title
                          searchText={searchText}
                          setSearchText={setSearchText}
                          name="Random People"
                          title={`${filteredRandom.length || 0}`}
                        />

                        <div className="noscroll request_height">
                          <Row className="ps-4 pe-4 pt-2 pb-5 g-3">
                            {/* ── Skeleton while loading ── */}
                            {isRandomLoading && filteredRandom.length === 0 ? (
                              Array.from({ length: SKELETON_COUNT }).map(
                                (_, i) => <SkeletonCard key={`sk-rand-${i}`} />
                              )
                            ) : filteredRandom.length === 0 ? (
                              /* ── No data found ── */
                              <NoDataFound
                                message={
                                  searchText
                                    ? `No people match "${searchText}"`
                                    : "No suggestions available"
                                }
                              />
                            ) : (
                              filteredRandom.map((e, index) => {
                                const status = getConnectionStatus(e);
                                const itemKey = e?._id || e?.userid || e?.shopid;
                                const isSending = sendingConnect[itemKey];

                                return (
                                  <Col
                                    key={itemKey || index}
                                    lg="3"
                                    md="3"
                                    sm="12"
                                    className="mt-2 fade-in"
                                  >
                                    <div className="friend-card border p-2" style={{ borderRadius: "8px", backgroundColor: "#fff" }}>
                                      {/* Top: avatar + name */}
                                      <div className="d-flex flex-column align-items-center w-100">
                                        <img
                                          src={resolveFriendAvatar(e)}
                                          alt="Profile"
                                          className="profile_img"
                                          crossOrigin="anonymous"
                                          onError={(ev) => {
                                            ev.currentTarget.src = dummyUser;
                                          }}
                                        />

                                        <h6
                                          className="font-sm mt-2 mb-0 text-truncate text-center w-100 px-1"
                                          title={e?.shopname || e?.fullname || e?.companyname || e?.profileName}
                                        >
                                          {e?.shopname || e?.fullname || e?.companyname || e?.profileName}
                                        </h6>
                                      </div>

                                      {/* View shop */}
                                      <div
                                        className="font_11 mob_f font-grey"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          const route =
                                            businessTypeRoutes[e?.businessType];
                                          const viewId =
                                            e?.shopid?._id || e?.shopid || e?.userid?._id || e?.userid || e?._id;
                                          if (route && viewId)
                                            navigate(`${route}${viewId}`);
                                        }}
                                      >
                                        <VisibilityIcon
                                          style={{ fontSize: "14px" }}
                                        />
                                        View Shop
                                      </div>

                                      {/* Connect / Pending / Connected button */}
                                      <button
                                        type="button"
                                        className="folow-btn mt-2"
                                        onClick={() => handleConnect(e)}
                                        disabled={
                                          isSending ||
                                          status === "Pending" ||
                                          status === "Connected"
                                        }
                                        style={{
                                          opacity:
                                            status === "Pending" ||
                                              status === "Connected"
                                              ? 0.65
                                              : 1,
                                          cursor:
                                            status === "Pending" ||
                                              status === "Connected"
                                              ? "not-allowed"
                                              : "pointer",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {isSending ? "Sending..." : status}
                                      </button>
                                    </div>
                                  </Col>
                                );
                              })
                            )}
                          </Row>
                        </div>

                        {selectedBT !== "marketerProfile" && randomTotal > 30 && (
                          <div className="mt-3 mb-2 d-flex justify-content-center">
                            <PaginationControl
                              page={randomPage}
                              between={4}
                              total={randomTotal}
                              limit={30}
                              changePage={(p) => {
                                setRandomPage(p);
                              }}
                              ellipsis={1}
                            />
                          </div>
                        )}
                      </Tab>
                    )}
                  </Tabs>
                </Col>
              </Row>
            </div>
          </Col>

          <Col lg="5" sm="12" className="ps-4 screenHeight position_r ">
            <div className="border b-radius">
              <Timeline
                tabsData={tabsData}
                activeTab={activeTab}
                onTabSelect={handleTabSelect}
                tabData={getActiveTabData()}
                loading={loading}
                createPost={createPost}
                setCreatePost={setCreatePost}
                setLoading={() => { }}
                // id={id}
                mybusinessType={createPost?.businessType}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Viewfriends;
